var _circle, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.8,
    cx: 40,
    cy: 40,
    r: 40,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19157_8303",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 16,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19157_8303)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.0539 53.1964C34.3872 53.6299 33.7119 53.6546 33.0279 53.2704C32.3452 52.8875 32.0039 52.2959 32.0039 51.4955V30.7845C32.0039 29.9841 32.3452 29.3917 33.0279 29.0075C33.7119 28.6247 34.3872 28.65 35.0539 29.0836L51.3539 39.4391C51.9539 39.8393 52.2539 40.4063 52.2539 41.14C52.2539 41.8737 51.9539 42.4407 51.3539 42.8409L35.0539 53.1964Z",
    fill: "#008FED"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayBtn);
export default __webpack_public_path__ + "static/media/play-btn.ce331ddf3ac0f9f4bb570f2bf6189bd6.svg";
export { ForwardRef as ReactComponent };